var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-item"},[_c('div',{staticClass:"logo",class:_vm.item.en}),_c('div',{staticClass:"data"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.chn))]),_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.item.num)+"小时")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }